import { render, staticRenderFns } from "./PetInsurances.vue?vue&type=template&id=0db7d3fe&scoped=true&"
import script from "./PetInsurances.vue?vue&type=script&lang=js&"
export * from "./PetInsurances.vue?vue&type=script&lang=js&"
import style0 from "./PetInsurances.vue?vue&type=style&index=0&id=0db7d3fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7d3fe",
  null
  
)

export default component.exports